export function fmt(s) {
  return `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;
}

export function formatSessionDuration(startedAt, now) {
  if (!startedAt) return "";
  const elapsedSec = Math.max(0, Math.floor((now - startedAt) / 1000));
  const h = Math.floor(elapsedSec / 3600);
  const m = Math.floor((elapsedSec % 3600) / 60);
  const s = elapsedSec % 60;
  const mm = String(m).padStart(2, "0");
  const ss = String(s).padStart(2, "0");
  return h > 0 ? `${h}h${mm}:${ss}` : `${mm}:${ss}`;
}
